import { render } from "./index.vue?vue&type=template&id=00573912&lang=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=00573912&lang=scss"

import exportComponent from "/Library/WebServer/Documents/pt/qizhonghui/frontend/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.13_vue@3.4.19_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__